import { post } from '@namespace/helpers';
import apiRoutes from '../apiRoutes';

export const getUserCryptoRate = ({ currency }) => {
  return post(apiRoutes.getUserCryptoRate, {
    base_currency: currency
  });
};
